(function paycheckEditControllerDefinition() {
    'use strict';

    angular.module('EmployeeFile')
        .controller('EmployeeFileEditController', [
            '$scope', 'config', '$rootScope', 'errorsExtend', '$stateParams', 'documentContainerService', 'authExtend', 'containerTypeService', '$window', '$filter', 'adminContainerTypeService',
            function employeeFileEditController($scope, config, $rootScope, errors, $stateParams, documentContainerService, authExtend, containerTypeService, $window, $filter, adminContainerTypeService) {

                $scope.preview = {
                    closed: true,
                    loading: false,
                    content: null,
                    index: null,
                    item: null,
                    invalid: false
                };

                $scope.containerType = null;

                $scope.tmpProcess = {
                    name: '',
                    metadatas: []
                };

                $scope.load = function () {
                    $scope.container = {
                        name: '',
                        code: '',
                        containerTypeId: config.custom('employeeFileTypeId'),
                        containerTypeName: '',
                        id: $stateParams.id,
                        parentDocumentContainerId: '',
                        metadatas: [],
                        documents: [],
                        organizationalUnitId: authExtend.getOrganizationId(),
                        organizationalUnitName: authExtend.getOrganizationName()
                    };
                    $scope.optionsContainerTypes = [];
                    $scope.optionsDocumentCategories = [];
                    $scope.optionsDocumentTypes = [];
                    $scope.nroLegSystemName = '_nroleg';

                    $scope.loadContainerType();
                };

                $scope.loadContainerType = function () {
                    adminContainerTypeService.getMetadataMappings(authExtend.getOrganizationRoot()).then(function (result) {
                        for (var i = 0; i < result.length; i++) {
                            if (result[i].sourceMetadataMapping.length > 0 && result[i].targetMetadataMapping.length > 0) {
                                $scope.containerType = result[i];
                            }
                        }

                        if ($scope.containerType) {
                            // Valido que tenga permisos para el tc
                            containerTypeService.isContainertypeInRole(['EMPLOYEEFILE WRITE', 'EMPLOYEEFILE ADM'], $scope.containerType.id).then(function (r) {
                                if (!r) {
                                    errors.showError('EDRTC');
                                    $scope.cancel();
                                }
                            }, function (error) {
                                errors.showError(error);
                                $scope.cancel();
                            });

                            $scope.containerType.targetMetadataMapping.forEach(function (item, index) {
                                if (item.metadataSystemName === $scope.nroLegSystemName) {
                                    $scope.nroLegSystemName = $scope.containerType.sourceMetadataMapping[index].metadataSystemName;
                                }
                            });

                            documentContainerService.checkout($scope.container).then(function (result) {
                                $scope.loadContainerMetadata(result);
                            }, function (error) {
                                errors.showError(error);
                                $window.history.back();
                            });
                        } else {

                            containerTypeService.getBySystemName("_leg").then(function (result) {
                                $scope.containerType = result;
                                documentContainerService.checkout($scope.container).then(function (result) {
                                    $scope.loadContainerMetadata(result);
                                }, function (error) {
                                    errors.showError(error);
                                    $window.history.back();
                                });

                            }, function (error) {
                                errors.showError(error);
                            });
                        }
                    });
                };

                $scope.loadContainerMetadata = function (type) {

                    $scope.container.name = type.name;
                    $scope.container.containerTypeName = type.containerTypeName;
                    $scope.container.metadatas = [];
                    $scope.container.containerTypeId = type.containerTypeId;
                    $scope.container.id = type.id;
                    $scope.container.organizationalUnitId = type.organizationalUnitId;
                    $scope.container.organizationalUnitName = type.organizationalUnitName;

                    $scope.containerType.metadata.forEach(function (metadata) {

                        if (metadata.metadataSystemName === $scope.nroLegSystemName) {
                            metadata.isReadOnly = true;
                        }

                        var metadataValue = $filter('filter')(type.metadatas, { metadataId: metadata.metadataId }, true);
                        var newMetadata = {
                            idObject: type.id + '' + metadata.metadataId,
                            metadataId: metadata.metadataId,
                            metadataIsRequired: metadata.isRequired,
                            metadataIsUnique: metadata.isUnique,
                            metadataType: metadata.metadataType,
                            metadataLabel: metadata.metadataLabel,
                            metadataOptions: metadata.optionValues,
                            metadataReplicate: metadata.isReplicated,
                            mask: metadata.metadataMask,
                            maskPlaceHolder: metadata.metadataMaskPlaceHolder,
                            metadataSystemName: metadata.metadataSystemName,
                            metadataReadOnly: metadata.isReadOnly,
                            metadataEnabled: true
                        };

                        if (metadataValue && metadataValue.length > 0) {
                            newMetadata.metadataValue = metadataValue[0].metadataValue;
                        }
                        
                        $scope.container.metadatas.push(newMetadata);
                    });

                };

                $scope.cancel = function () {
                    $window.history.back();
                };

                $scope.save = function () {
                    if (!$scope.employeeFileForm.$valid) {
                        $scope.employeeFileForm.$setSubmitted();
                        errors.showError('VerifyContainerFormData');
                        return false;
                    }

                    return documentContainerService.modifyAndCheckIn($scope.container).then(function () {
                        $window.history.back();
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.load();

                $rootScope.$on('$stateChangeStart',
                    function (event, toState, toParams, fromState, fromParams, options) {
                        if (fromState.name === 'employee-file-edit') {
                            documentContainerService.checkIn($scope.container);
                        }
                    });
            }]);
})();
